import ImportarProductosPage from "../pages/ImportarProductosPage/index.vue";

const routes = [
  {
    name: "ImportarProductosPage",
    path: "/importar-productos",
    component: ImportarProductosPage,
    meta: {
      requiresAuth: true,
      permission: "PRODUCTO_IMPORTAR",
    },
  },
];

export default routes;
